var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"lbLoadingPlaceholder\">\n<div class=\"lbLoadingPlaceholder_content\" ng-transclude></div>\n</div>";
var id1="components/lbLoadingPlaceholder/lbLoadingPlaceholder.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;


//////////////////
// WEBPACK FOOTER
// ./src/components/lbLoadingPlaceholder/lbLoadingPlaceholder.html
// module id = 1211
// module chunks = 1